// @ts-nocheck
import "./App.css";
import HomePage from "./Components/HomePage/HomePage";
import $ from "jquery";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { useEffect } from "react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PrivacyPage from "./Components/PrivacyPage/PrivacyPage";
import TermsConditionPage from "./Components/TermsConditionPage/TermsConditionPage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {
	return (
		// <div className='App'>
		// <Router basename='/redonline/199'>
		<Router >

			<Switch >
				<Route exact path='/'><HomePage /></Route>
				<Route exact path='/privacy-policy'><PrivacyPage /></Route>
				<Route exact path='/terms-conditions'><TermsConditionPage /></Route>
			</Switch>
		</Router>



		// </div>
	);
}

export default App;
